<template lang="html">
  <div id="Slides" @mousemove="handleMouse">
    <!-- <Slide :key="current" :slide="slides.get(current)" /> -->
    <component v-bind:is="current"></component>
    <!-- <Nav :show="displayUI" :uiOverride="setDisplayUIOverride" /> -->
    <!-- <Escape :show="displayUI" :active="escapeActive" :set="setEscape" :uiOverride="setDisplayUIOverride" /> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import Slide from "./Slide.vue"
import Nav from "./Nav.vue"
import Escape from "./Escape.vue"

import Sun from "./Scenes/Sun.vue"
import Landscape from "./Scenes/Landscape.vue"

const sceneMap = {
  "scene-1": Sun,
  "scene-2": Landscape,
}

export default {
  data: function() { return {
    escapeActive: false,
    navActive: false,
    uiTmt: null,
    displayUI: false,
    displayUIOverride: false,
    current: this.$route.params.slug,
  } },
  computed: {
    ...mapState([
      "slides",
    ]),
  },
  watch: {
    $route: function(to, from) {
      this.current = to.params.slug
    },
  },
  methods: {
    setDisplayUI(to) { this.displayUI = to },
    setDisplayUIOverride(to) { this.displayUIOverride = to },
    setEscape(to) { this.escapeActive = to },
    handleMouse() {
      window.clearTimeout(this.uiTmt)
      if (!this.displayUI) { this.setDisplayUI(true) }
      this.uiTmt = window.setTimeout(() => {
        if (this.displayUIOverride) { return }
        this.setDisplayUI(false)
      }, 1000)
    },
  },
  components: {
    Slide,
    Nav,
    Escape,
    ...sceneMap,
  }
}
</script>

<style lang="scss">
#Slides {
  width: 100%; height: 100%; overflow: hidden;
  -webkit-overflow-scrolling: auto;
}
</style>
